module.exports = __webpack_public_path__ + "img/title-base.d2e159fa.png";